export default __webpack_public_path__ + "static/media/HeartBlack.131178b2.svg";